<template>
  <home-layout>
    <v-card>
      <v-card-title>
        <h1>
          <div :class="`currency-flag currency-flag-${label.toLowerCase()}`"></div>
          {{currency.name}}
        </h1>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-progress-circular indeterminate :size="50" color="primary" v-if="isInitLoading" />
        <v-container fluid v-else>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="text-xs-center mb-3">
                Currency code: {{label}}
              </h1>
            </v-flex>
            <v-flex xs12>
              <v-tabs
                v-model="tab"
                color="cyan"
                dark
                grow
                slider-color="yellow"
              >
                <v-tab
                  ripple
                  href="#analytic"
                >
                  Analytic
                </v-tab>
                <v-tab
                  ripple
                  href="#convert"
                >
                  Convert
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item id="convert">
                  <convert-box :countryFrom="label" />
                </v-tab-item>
                <v-tab-item id="analytic">
                  <v-card>
                    <v-card-text>
                      <v-container fluid>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <select-currency label="Compare with" @change="updateCurrencyCompare" :multiple="true"/>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-container>
        <analytic-chart v-if="tab == 'analytic'" class="wow fadeIn"
          :chart-data="chartData"
          :options="options"
        />
      </v-card-text>
    </v-card>
  </home-layout>
</template>

<script>
import currencyHelper from '../../helper/currency'
import currencyService from '../../service/currency'
import ConvertBox from 'component/converter/ConvertBox'
import AnalyticChart from 'component/chart/Analytic'
import randomColor from 'randomcolor'
import SelectCurrency from 'component/converter/SelectCurrency'

export default {
  props: ['label'],
  components: {
    ConvertBox, AnalyticChart, SelectCurrency
  },
  data: () => ({
    currency: {
      name: null,
      history: null
    },
    isInitLoading: true,
    selectedDate: null,
    tab: 'analytic',
    currencyCompare: ['USD'],
    chartData: null,
    options: null
  }),
  watch: {
    currency: {
      deep: true,
      handler () {
        this.updateChartData()
      }
    }
  },
  methods: {
    getCurrencyOfDate (date) {
      return this.currency.history.filter(v => v.date == date)[0]
    },
    updateCurrencyCompare (currency) {
      this.currencyCompare = currency
      this.updateChartData()
    },
    updateChartData () {
      if (!this.currency.history) this.chartData = null
      let currencyHistory = Object.assign([], this.currency.history).reverse()
      let datasets = Object.values(this.currencyCompare).map(currency => {
        return {
          label: `${currency}`,
          backgroundColor: randomColor(),
          data: Object.values(currencyHistory).map((v, index) => {
            if (index < 30) {
              let result = currencyHelper.customConvert(v.currencies[`USD${currency}`], v.data, 1)
              return result
            }
          }).filter(n => n).reverse(),
          fill: false
        }
      })
      this.options = {
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              return `1 ${data.datasets[tooltipItems.datasetIndex].label} = ${tooltipItems.yLabel} ${this.label}`
            }
          }
        },
        responsive: true, 
        maintainAspectRatio: false
      }
      let labels = Object.values(currencyHistory).map((v, index) => {
        if (index < 30) {
          return v.date
        }
      }).filter(n => n).reverse()
      this.chartData = {
        labels,
        datasets
      }
    }
  },
  async created () {
    this.currency.history = await currencyService.getCurrency(this.label)
    this.selectedDate = currencyService.date
    this.currency.name = currencyHelper.getNameOfCurrency(this.label)
    this.updateChartData()
    this.isInitLoading = false
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/currencies/_label.vue